/**
 * This is the InfoPage module configuration.
 * Do NOT configure routes in this file.
 * @memberOf InfoPage Module
 * @namespace InfoPage Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf InfoPage Module.InfoPage Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/infopage/infopage.config.js